import { RevenueReportListPage } from "@/features/revenue-report/pages/RevenueReportListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-report/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportListPage,
});
